<template>
  <div class="unit-items">
    <div class="unit-title">
      <div class="d-flex">
        <v-btn @click="add" class="ma-1 white" small light>
          Add a year <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>
    </div>

    <draggable
      class="inner mt-5"
      :list="items"
      group="order"
      @start="startDrag()"
      @end="endDrag()"
      :ref="name"
      :id="name"
    >
      <div
        v-for="(item, index) in items"
        :key="`unit-${index}`"
        class="item mb-5 pa-4"
        :data-id="`${Math.round(new Date().getTime() / 1000)}`"
      >
        <div class="d-flex flex-row justify-space-between align-start">
          <v-row>
            <v-col cols="4">
              <p class="break-spaces text-h2 white--text">
                {{ item.year }}
              </p>
            </v-col>
            <v-col cols="8">
              <h2 class="break-spaces text-h5 white--text">
                {{ item.title }}
              </h2>
              <p
                v-if="item.description"
                v-html="item.description"
                class="white--text break-spaces pa-2"
              ></p>
            </v-col>
          </v-row>

          <div class="icons pa-1">
            <v-icon @click="edit(item)" class="white--text">mdi-pencil</v-icon>
            <v-icon @click="remove(item)" class="white--text"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>

        <!-- <v-row>
          <v-col cols="6">
            <h4 class="white--text">Narrative</h4>
          </v-col>
          <v-col cols="3">
            <h4 class="white--text">Tone</h4>
          </v-col>
          <v-col cols="3">
            <h4 class="white--text">Potential criticism</h4>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12">
            <timeline-row-cols
              v-model="item.matrix"
              :headers="content.headers"
              :name="item.year"
              :year="item.year"
              :filters="filters"
              @autosave="$emit('autosave')"
            />
          </v-col>
        </v-row>
      </div>
    </draggable>

    <v-dialog v-model="dialog" max-width="800">
      <!-- Delete  -->

      <v-card light v-if="dialogMode == 'remove'">
        <v-card-title>
          Are you sure you want to remove this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeCommit"
            >Delete</v-btn
          >
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'edit'">
        <timeline-edit :doc="activeCard" @editCommit="editCommit">
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </timeline-edit>
      </v-card>

      <v-card light v-if="dialogMode == 'add'">
        <timeline-add @addCommit="addCommit">
          <v-btn
            light
            color="white"
            class="mt-10 mt-2 mr-2"
            @click="closeDialog"
            >Close</v-btn
          >
        </timeline-add>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
import TimelineAdd from "@/views/user/exercises/timeline/TimelineAdd";
import TimelineEdit from "@/views/user/exercises/timeline/TimelineEdit";
import TimelineRowCols from "@/views/user/exercises/timeline/TimelineRowCols";

var defaults = {
  year: "",
  title: "",
  description: "",
  items: [],
  matrix: {
    list1: [],
    list2: [],
    list3: [],
    list4: [],
    list5: [],
    list6: [],
    list7: [],
    list8: [],
  },
};
export default {
  name: "TimelineRow",
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      items: this.value,
      item: {
        year: "",
        title: "Default",
        description: "",
        items: [],
        matrix: {
          list1: [],
          list2: [],
          list3: [],
          list4: [],
          list5: [],
          list6: [],
          list7: [],
          list8: [],
        },
      },
      currIndex: null,
      refs: null,
      fields: [],
      dialogMode: "",
      activeCard: null,
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
      counter: 0,
    };
  },

  components: {
    draggable,
    TimelineRowCols,
    TimelineAdd,
    TimelineEdit,
  },
  watch: {
    value: {
      handler: function(val) {
        // console.log("input value updated", val);
        this.items = val;
      },
      deep: true,
    },
    items: {
      handler: function(val) {
        // console.log("emit value changed", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      this.item = defaults;
      this.dialogMode = "add";
      this.dialog = true;
    },
    addCommit($event) {
      let item = {
        index: this.items.length,
        id: new Date().valueOf(),
        ...$event,
        matrix: {
          list1: [],
          list2: [],
          list3: [],
          list4: [],
          list5: [],
          list6: [],
          list7: [],
          list8: [],
        },
      };
      this.items.push(item);
      this.closeDialog();
      this.$emit("autosave");
    },
    remove($event) {
      this.activeCard = $event;
      this.dialogMode = "remove";
      this.dialog = true;
    },
    removeCommit() {
      let items = this.items;
      let item = items.find((x) => x.id === this.activeCard.id);

      let indexOfItem = items.indexOf(item);
      items.splice(indexOfItem, 1);
      this.closeDialog();
    },
    edit($event) {
      this.activeCard = $event;
      this.dialogMode = "edit";
      this.dialog = true;
    },
    editCommit() {
      let items = this.items;
      let item = items.find((x) => x.id === this.activeCard.id);
      let indexOfItem = items.indexOf(item);
      this.$set(items, indexOfItem, item);
      this.closeDialog();
      this.$emit("autosave");
    },
    closeDialog() {
      this.dialogMode = "";
      this.activeCard = null;
      // this.$set(this.activeCard, null);
      this.dialog = false;
      this.item = {};
      this.$set(this.item, {});
      this.$set(this.item, "matrix", []);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.items.indexOf(item);
          item.index = count;
          vm.$set(vm.items, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
      this.$emit("autosave");
    },
  },
};
</script>

<style lang="scss" scoped>
.unit-items {
  .item {
    &--flex {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
    padding: 0.5rem;
    margin: 0.5rem 0;
    background: rgb(38, 38, 38);
    border-radius: 5px;
    color: black;
    .icons {
      width: 50px;
      padding: 0 10px 0 10px;
      display: flex;
    }
  }
}
.unit-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.add-button {
  margin: 0 !important;
  position: relative;
  right: 0;
}
.unit-field {
  margin: 0.75rem 0 !important;
}
.no-bullets {
  list-style: none;
  margin: 0;
  padding: 0 0 0px 0px;
  li {
    padding: 3px 0;
    border-bottom: dotted 1px #333;
  }
}
</style>
